import { Link as ShrikeLink } from '@perch-labs/shrike';
import styled from 'styled-components';
import { layout, flexbox, typography } from 'styled-system';

export const StyledLink = styled(ShrikeLink)`
  ${layout}
  ${flexbox}
  ${typography}
`;
